import React, { useEffect, useState, useCallback } from 'react';
import { db, setDoc,doc, getDoc , collection, getDocs, query, where } from '../../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const Mapping = ({ onSave,soal, data }) => {
   
  
    const [pembelajaran, setPembelajaran] = useState([]); // Menyimpan ID pembelajaran yang dipilih
    const [error, setError] = useState('');
    const [informasiAkun, setInformasiAkun] = useState(null); // State untuk menyimpan informasi akun
    const navigate = useNavigate();
   

    // Handle perubahan checkbox
    const handleCheckboxChange = (id) => {
     

        setPembelajaran((prevSelected) =>
            prevSelected.includes(id)
              ? prevSelected.filter((i) => i !== id) // Hapus jika sudah ada
              : [...prevSelected, id] // Tambah jika belum ada
          );
    };

    // Kirim data ke parent saat tombol "Simpan" diklik
    const handleSaveSoal = () => {
        console.log(pembelajaran)
        onSave(pembelajaran);
    };

    return (
        <div>
            <div className='row'>
                <div className="col-xl-12 col-md-12">
                    {soal?.length}
                    <table className="table table-borderless mb-0">
                        <thead>
                            <tr>
                                <th>
                                    <input className="form-check-input" type="checkbox" /> ALL
                                </th>
                                <th>Pelajaran (Kelas)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((item) => (
                                <tr key={item.id_ujian}>
                                    <td align='right' width={20}>
                                    <input 
                                                className="form-check-input" 
                                                value={item.id_ujian } 
                                                onChange={() => handleCheckboxChange(item.id_ujian)} 
                                                type="checkbox" 
                                                checked={pembelajaran.includes(item.id_ujian)}
                                            />
                                                                                </td>
                                    <td>
                                    <h5 className="mb-0">{item.nama_guru} ({item.id_ujian})</h5>
                                        <h5 className="mb-0">{item.nama_mapel} ({item.id_ujian})</h5>
                                        <small className="text-danger">{item.nama_rombel}</small>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <button type='button' className='btn btn-secondary d-inline-flex' onClick={handleSaveSoal}>Simpan</button>
        </div>
    );
};

export default Mapping;
